module.exports = __webpack_public_path__ + "static/media/card-American-Express-inactive.bbd8fbaa.svg";